var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhotoUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 41,
    fill: "#F6F8F9",
    stroke: "#151B26",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9202 50.0473C57.9202 50.8228 57.6121 51.5665 57.0637 52.1149C56.5154 52.6633 55.7716 52.9714 54.9961 52.9714H28.679C27.9035 52.9714 27.1597 52.6633 26.6113 52.1149C26.063 51.5665 25.7549 50.8228 25.7549 50.0473V33.9646C25.7549 33.1891 26.063 32.4453 26.6113 31.8969C27.1597 31.3486 27.9035 31.0405 28.679 31.0405H34.5272L37.4514 26.6543H46.2237L49.1478 31.0405H54.9961C55.7716 31.0405 56.5154 31.3486 57.0637 31.8969C57.6121 32.4453 57.9202 33.1891 57.9202 33.9646V50.0473Z",
    stroke: "#151B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8375 47.1232C45.0674 47.1232 47.6857 44.5049 47.6857 41.275C47.6857 38.0451 45.0674 35.4268 41.8375 35.4268C38.6076 35.4268 35.9893 38.0451 35.9893 41.275C35.9893 44.5049 38.6076 47.1232 41.8375 47.1232Z",
    stroke: "#151B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0325 58.9322C61.1382 58.9322 63.6558 56.4145 63.6558 53.3089C63.6558 50.2032 61.1382 47.6855 58.0325 47.6855C54.9268 47.6855 52.4092 50.2032 52.4092 53.3089C52.4092 56.4145 54.9268 58.9322 58.0325 58.9322Z",
    fill: "#F6F8F9",
    stroke: "#151B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0322 51.0596V55.5582",
    stroke: "#151B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7832 53.3086H60.2818",
    stroke: "#151B26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4959,
    height: 13.4959,
    fill: "white",
    transform: "translate(51.2842 46.5605)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhotoUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/photoUpload.35e67695.svg";
export { ForwardRef as ReactComponent };